import { render, staticRenderFns } from "./itemInfo.vue?vue&type=template&id=7c0b9712&scoped=true"
import script from "./itemInfo.vue?vue&type=script&lang=js"
export * from "./itemInfo.vue?vue&type=script&lang=js"
import style0 from "./itemInfo.vue?vue&type=style&index=0&id=7c0b9712&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0b9712",
  null
  
)

export default component.exports